<template>
  <li class="nav-item">
    <a
      class="nav-link"
      data-bs-toggle="collapse"
      aria-expanded="false"
      :href="`#${refer}`"
      @click.prevent="showHide()"
    >
      <i class="material-icons-round opacity-10 fs-5">{{miniIcon}}</i>
      <span class="sidenav-normal me-3 ms-2 ps-1">
        <span v-html="text"></span> <b class="caret"></b
      ></span>
    </a>
    <div class="sidenav-collapse-item collapse" :class="'sidenav-collapse-item-' + sidenavKey">
      <ul class="nav nav-sm flex-column">
        <slot name="nav-child-item" />
      </ul>
    </div>
  </li>
</template>

<script>
import $ from "jquery";

export default {
  name: "SidenavCollapseItem",
  props: {
    refer: {
      type: String,
      required: true,
    },
    miniIcon: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    sidenavKey: {
      type: String,
      required: true,
    },
    collapseRef: {
      type: String,
      default: ''
    },
  },
  methods: {
    showHide() {
      var check = false;
      var element = $('.sidenav-collapse-item-' + this.sidenavKey);

      if (element.hasClass('show')) {
        check = true;
      }

      const productivityKeys = ['2221', '2222', '2223', '2224', '2225'];
      const settingKeys = ['1111', '1112'];
      const megaposKeys = ['3331', '3332', '3333', '3334', '3335'];

      if (productivityKeys.includes(this.sidenavKey)) {
        if (check) {
          // if check = true, then close the child menu (parent menu still open)
          element.removeClass('show');
          return;
        }
        // close other child menu in the same level
        productivityKeys.forEach(key => {
          if (key !== this.sidenavKey) {
            $('.sidenav-collapse-item-' + key).removeClass('show');
          }
        });
        // open parent menu Productivity Tools
        $('.sidenav-collapse-item-222').addClass('show');
      } else if (settingKeys.includes(this.sidenavKey)) {
        if (check) {
          // if check = true, then close the child menu (parent menu still open)
          element.removeClass('show');
          return;
        }
        // close other child menu in the same level
        settingKeys.forEach(key => {
          if (key !== this.sidenavKey) {
            $('.sidenav-collapse-item-' + key).removeClass('show');
          }
        });
        // open parent menu Productivity Tools
        $('.sidenav-collapse-item-111').addClass('show');
      } else if (megaposKeys.includes(this.sidenavKey)) {
        if (check) {
          element.removeClass('show');
          return;
        }
        megaposKeys.forEach(key => {
          if (key !== this.sidenavKey) {
            $('.sidenav-collapse-item-' + key).removeClass('show');
          }
        });

        $('.sidenav-collapse-item-333').addClass('show');
      } else if (this.sidenavKey == 34) {  // Business Insights
        if (check) {
          // if check = true, then close the child menu (parent menu still open)
          element.removeClass('show');
          return;
        }
        $('.sidenav-collapse-item:not(.sidenav-collapse-item-33)').removeClass('show');
      } else {
        $('.sidenav-collapse-item').removeClass('show');
      }

      if (!check) {
        element.addClass('show');

        if (this.collapseRef && this.collapseRef !== '') {
          this.$router.push(this.collapseRef);
        }
      }
    }
  }
};
</script>
<style>
#sidenav-collapse-main ul li ul {
  padding-left: 20px;
}
.navbar-vertical .navbar-nav .nav-item .collapse .nav .nav-item .nav-link,
.navbar-vertical .navbar-nav .nav-item .collapsing .nav .nav-item .nav-link {
  color: #ffffff !important;
}
.navbar-vertical .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
  color: #ffffff !important;
}
</style>
